const { regClass, property } = Laya;
import GameLevel from "./GameLevel";
import Toy from "./Toy";
import * as consts from "./const";




@regClass('GN9WJGRsR4OOfUBtyj3AEw')
export default class Stock extends Laya.Script {    
    public stock_index:number = 0;
    //public point:number[] = [0,0];
    public expect_num:number = 0;
    public toys:Toy[] = [];
    public tag:Laya.Text = null;

    public in_range_toys:Toy[] = [];
    public count_down:number = 0;

    constructor() { super(); }

    // onEnable(): void {
    // }

    onTriggerEnter(other: any, self: any, contact: any): void {
        //console.log("on Stock TriggerEnter");
        let sprite = other.owner as Laya.Sprite;
        if(!sprite.visible) {
            return;
        }
        let toy = sprite.getComponent(Toy);
        if(toy) {
            this.pushInRange(toy);
        }
    }

    onTriggerExit(other: any, self: any, contact: any): void {
        //console.log("on Stock TriggerExit");
        // let toy = other.owner.getComponent(Toy);
        // if(toy) {
        //     this.popInRange(toy);
        // }
    }

    onUpdate() {
        let sprite = this.owner as Laya.Sprite;
        for(let i = 0; i < this.in_range_toys.length; i++) {
            let script = this.in_range_toys[i];
            let toy = script.owner as Laya.Sprite;
            let dx = toy.x - sprite.x;
            let dy = toy.y - sprite.y;

            if( (dx * dx + dy * dy) > consts.STOCK_SQR_RADIUS) {
                this.popInRange(script);
            }
        }
    }

    pushInRange(toy : Toy) {
        for(let i = 0; i < this.in_range_toys.length; i++) {
            if(this.in_range_toys[i] == toy) {
                return;
            }
        }
        this.count_down = consts.STOCK_COUNT_DOWN;
        this.in_range_toys.push(toy);
        if(this.in_range_toys.length > 1) {
            this.count_down = consts.STOCK_COUNT_DOWN;
        }

    }
    popInRange(toy : Toy) {
        for(let i = 0; i < this.in_range_toys.length; i++) {
            if(this.in_range_toys[i] == toy) {
                this.in_range_toys.splice(i, 1);
                return;
            }
        }
    }



    popToy() : Toy {
        //console.log("popToy", this.stock_index);
        let toy = this.toys.pop();
        this.pushInRange(toy);
        return toy;
    }
    // onDisable(): void {
    // }

}